import React from 'react';
import { FlatList } from 'react-native';
import DefaultLabel from 'components/UI/Labels/DefaultLabel';
import Container from 'components/UI/Layout/Container';
import TouchablePanel from './TouchablePanel';

interface Props<T> {
  data?: T[];
  keyExtractor: (item: T) => string;
  renderItem: (item: T, index: number) => React.ReactNode;
  onItemPressed: (item: T) => void;
  emptyCaption?: string;
}

function TouchablePanelList<T>(props: Props<T>) {
  if (props.data && props.data.length) {
    return (
      <Container>
        <FlatList
          data-testid="touchable-panel-list"
          data={props.data}
          keyExtractor={props.keyExtractor}
          renderItem={({ item, index }) => (
            <TouchablePanel onPress={() => props.onItemPressed(item)}>
              {props.renderItem(item, index)}
            </TouchablePanel>
          )}
        />
      </Container>
    );
  }

  return (
    <Container>
      <DefaultLabel>{props.emptyCaption}</DefaultLabel>
    </Container>
  );
}

TouchablePanelList.defaultProps = {
  data: [],
  emptyCaption: undefined
};

export default TouchablePanelList;
